import React, { memo } from "react";

import { CustomModal } from "../../../../../components/CustomModal";
import { DeleteApplicationFooter } from "./DeleteApplicationFoter";

interface IProps {
  show: boolean;
  app: { name: string; id: string } | null;
  closeModal: () => void;
  deleteApplication: () => void;
  isProcessing: boolean;
  errorMessage: string;
  disabledSubmit: boolean;
}

const DeleteApplicationModal: React.FC<IProps> = memo(
  ({
    show,
    app,
    closeModal,
    deleteApplication,
    isProcessing,
    errorMessage,
    disabledSubmit,
  }) => {
    return (
      <CustomModal
        title="Delete project"
        show={show}
        handleClose={closeModal}
        footer={
          <DeleteApplicationFooter
            disabledSubmit={disabledSubmit}
            isProcessing={isProcessing}
            cancelDelete={closeModal}
            deleteApplication={deleteApplication}
          />
        }
        errorMessage={errorMessage}
      >
        <div>
          <p>
            The project <b>{app?.name}</b> will be deleted.{" "}
          </p>

          <p>Are you sure you want to delete the project?</p>
        </div>
      </CustomModal>
    );
  },
);

export { DeleteApplicationModal };
